import { useCallback } from "react";
import FilterIcon from "../../../icons/FilterIcon";
import SearchIcon from "../../../icons/SearchIcon";
import DownloadIcon from "@mui/icons-material/Download";
import Button from "../../../toolkit/ButtonV1";
import FormControl from "../../../components/FormControl";
import { useNavigate } from "react-router-dom";
import React, { useMemo, useState } from "react";
import _ from "lodash";
import { Divider, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import { Card, Grid, Box } from "@mui/material";
import { useEffect } from "react";
import PlusIcon from "../../../icons/PlusIcon";
import Dialog from "@mui/material/Dialog";
// import Adduser from "./Adduser";
import axios from "../../../utils/fvAxios";
import fileDownload from "js-file-download";
import ExportToExcel from "../../../utils/ExportToExcel";
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";

const searchDebounceDelay = 1000;

export default function CompanyCollectionControls({
  searchStr: parentSearchStr,
  setSearchStr: parentSetSearchStr,
  setCompanyType: parentSetCompanyType,
  selectedOrgTypes: parentOrgTypes,
  setFilterType: parentSetFilterType,
  selectedFilterType: parentFilter,
  orgTypes,
  viewType,
  toggleViewType,
  openSlidingPopup,
  largeScreen,
  downloadUrl,
  fileName,
  sheetName,
}) {
  const [searchStr, setSearchStr] = useState(parentSearchStr);
  //const [companyType, setCompanyType] = useState(parentCompanyType);
  //const [selectedOrgTypes, setSelectedOrgTypes] = useState(parentOrgTypes); 

  const [open, setOpen] = useState(false);

  const FilterTypes = [
    { value: "Name", text: "Name" },
    { value: "Taxid", text: "Tax ID" },
  ];
  // const [orgTypes, setOrgTypes] = useState([]);
  const navigate = useNavigate();
  function optionsDataMapper({ key, value }) {
    return {
      value: key,
      text: value,
    };
  }

  const debouncedSearchQueryHandler = useCallback(
    _.debounce(parentSetSearchStr, searchDebounceDelay),
    []
  );

  useEffect(() => {
    if (parentSearchStr !== searchStr) {
      debouncedSearchQueryHandler(searchStr);

    }
  }, [searchStr]);

  useEffect(() => {
    setSearchStr(parentSearchStr);
  }, [parentSearchStr]);

  function handleChange(data) {
    //setSelectedOrgTypes(data);
    parentSetCompanyType(data);
  }

  function ChangeFilter(data) {
    setSearchStr("");
    parentSetFilterType(data);

  }

  const { t } = useTranslation();

  const handleClickOpen = () => {
    navigate(
      "/AddNewCompany"
    )

  };
  const handleClose = () => {
    setOpen(false);
  };
  const onUserSearch = () => {
    // onUserSearchClick();
  };
  return (
    <Card style={{ marginBottom: "1rem", border: "none" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "15px",
          "& svg": { m: 1.5 },
          "& hr": { mx: 0.5 },
        }}
      >
        <Grid
          container
          wrap="nowrap"
          sx={{ flexDirection: { xs: "column", md: "row", oveflow: "auto" } }}
          spacing={2}
          justify="flex-start"
        >
          <Grid item xs={9}>
            <h2 style={{ float: "left" }}>
              {t("Companies.companylist")}
            </h2>
          </Grid>
          <Grid item xs={3}>
            {HasPermissions(INFO?.AddNewCompany?.actionName, "R") &&
              <Button
                sx={{ marginLeft: "170px" }}
                role="primary"
                size="default"
                trailingComponent={<PlusIcon />}
                label="Add New"
                onClick={handleClickOpen}
              />
            }
            <Dialog
              maxWidth={"sm"}
              fullWidth={true}
              open={open}
              onClose={handleClose}
              width="450"
              className="w-100"
            >
              {/* <Adduser close={handleClose} /> */}
            </Dialog>
          </Grid>
        </Grid>
      </Box>

      <Divider
        style={{ height: "1.5px", backgroundColor: "rgb(130 133 137)" }}
      />
      <Box
        style={{ padding: "16px" }}
        sx={{ "& h1": { m: 0 } }}
      >
        <Grid
          container
          wrap="nowrap"
          sx={{ flexDirection: { xs: "column", md: "row", oveflow: "auto" } }}
          spacing={1}
          justify="flex-start"
        >
          <Grid item xs={3}>
            <span>Search Criteria</span>
            <FormControl
              fieldId={"FilterTypes"}
              required={false}
              inputType="select"
              multiple={false}
              isSelectAll={false}
              items={FilterTypes}
              value={parentFilter || ""}
              handleChange={ChangeFilter}
              width={"100%"}
              disabled={false}
              heighlight={"false"}
            />
          </Grid>
          <Grid item xs={3}>
            <span>&nbsp;</span>
            <FormControl
              inputType="text"
              placeholder={parentFilter == "Name" ? "Search by Name" : "Search by Tax ID"}
              value={searchStr}
              handleChange={setSearchStr}
              setValidate={() => { }}
            />
          </Grid>
          <Grid item sx={{ marginLeft: "auto" }}>
            <span>&nbsp;</span>
            <FormControl
              fieldId={"orgTypes"}
              required={false}
              inputType="select"
              multiple={true}
              isSelectAll={false}
              items={orgTypes}
              value={parentOrgTypes || ""}
              handleChange={handleChange}
              width={"100%"}
              disabled={false}
              heighlight={"false"}
            />
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
}
